
  import {
    mapSectionComponents,
    replaceCityDataInSections,
  } from '@/helper/SectionHelper';
  import {getMetaTags, replaceCityDataInMetaData} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'LandingPageStudentenjobsCities',
    components: {
      LazyHydrate,
    },
    async asyncData({app, route, error, $cachedStrapi}) {
      const pagePromise = $cachedStrapi
        .findOne('pages', 'landingpages-studentenjobs-city')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const cityPromise = $cachedStrapi
        .findOne('cities', 'studentenjobs-' + route.params.city)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }

          return $cachedStrapi
            .findOne('cities', route.params.city)
            .catch((e) => {
              if (e.statusCode !== 404) {
                throw e;
              }
            });
        });

      const [page, city] = await Promise.all([pagePromise, cityPromise]);

      if (!scopeHelper(page, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }
      if (!scopeHelper(city, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'City not found'});
        return;
      }

      // Map section components and replace city data/placeholder
      let sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'index',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.landingpage_studentenjobs'),
                  disabled: false,
                  to: app.localePath({
                    name: 'landingpages-studentenjobs',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: city.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'landingpages-studentenjobs-city',
                    params: {
                      city: city.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );
      sections = replaceCityDataInSections(sections, city);

      const metaData = replaceCityDataInMetaData(page.meta ?? {}, city);

      return {
        metaData,
        sections,
        city,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
        city: {},
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
  };
